import './try-again-message.scss';
import React from 'react';
import CustomButton from '../custom-button/custom-button';
import NoResultsIcon from '@svg/no-results.svg?react';
import { tryAgainClassName } from 'src/utils/constants';

export const TryAgainMessage: React.FC<{ onclick?: () => void, message?: string | React.ReactNode }> = ({ onclick, message }) => {
    return <div className={tryAgainClassName}>
        <NoResultsIcon />
        {message ?? <span>Data is unavailable. Please try again later.</span>}
        {onclick && <CustomButton className="secondary-btn try-again-button" label="Try Again" onClick={onclick} />}
    </div>;
};